import { render, staticRenderFns } from "./OrderNotesReport.vue?vue&type=template&id=76e598f4&"
import script from "./OrderNotesReport.vue?vue&type=script&lang=js&"
export * from "./OrderNotesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports